module.exports = __webpack_public_path__ + "static/media/sign-out.530cc5c2.svg";